import { Alert, Button, Card, Form, Input, message, notification } from 'antd';
import React, { useState } from 'react';
import authService from '../../../services/admin/auth.service';
import ContainerComponent from '../../../helpers/components/container.component';
import { useHistory } from 'react-router-dom';

const LoginLayout = () => {
    const history = useHistory();
    const [form] = Form.useForm();
    const [state, setState] = useState({
        login_loading : false,
        fail_login : false,
    })
    const onLogin = async () => {
        setState(state => ({...state, login_loading : true,}));
        const { username, password } = form.getFieldsValue();
        const loginResponse = await authService.login({
            username : username,
            password : password,
        }).catch(err => {
            const status = (err?.response?.request?.status)
            if(status === 401){
                message.error({
                    content : 'Invalid Credential',
                    duration : 3,
                })
            }else{
                notification?.error({
                    message : 'Oops, something went wrong',
                    description : 'Please contact support'
                })
            }
            setState(state => ({...state, login_loading : false, fail_login : true,}));
        });

        setState(state => ({...state, login_loading : false,}));
        if(loginResponse?.token){
            //success login
            window.location.reload(false);
        }
    }

    return (
        <>
            <div className='content' style={{display:'flex', justifyContent:'center', flexDirection : 'column'}}>
                <div>
                    <div>
                        <div>
                            <span
                            className='ticket-label ticket-title h1'
                            style={{
                                fontWeight:'bold',
                                fontSize: 24
        
                            }}
                            >
                                Enter your credentials
                            </span>
                        </div>
                    </div>

                    <div style={{marginTop:42,}}>
                        <Form
                        form={form}
                        onFinish={onLogin}
                        >
                            <Form.Item name={'username'}>
                                <Input size='large' placeholder='Username'/>
                            </Form.Item>

                            <Form.Item name={'password'}>
                                <Input size='large' placeholder='Password' type='password'/>
                            </Form.Item>

                            <Form.Item>
                                <Button loading={state?.login_loading} htmlType='submit' type='primary' size='large' style={{width:'100%'}}>
                                    Sign In
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LoginLayout;